import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_ModelSummaryCard = _resolveComponent("ModelSummaryCard")!
  const _component_ModelCard = _resolveComponent("ModelCard")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_VoiceSummaryCard = _resolveComponent("VoiceSummaryCard")!
  const _component_VoiceCard = _resolveComponent("VoiceCard")!
  const _component_ConfigCardOverlay = _resolveComponent("ConfigCardOverlay")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "my-0 ml-0 mr-n2 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("h3", null, "LLMs", -1)
            ])),
            _: 1,
            __: [7]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "ma-0 pa-2 d-flex align-center"
          }, {
            default: _withCtx(() => [
              (_ctx.count > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    buttonClass: "ml-1",
                    icon: "mdi-plus",
                    click: _ctx.openCreateModelOverlay,
                    size: "x-large",
                    tooltip: "New Model",
                    variant: "outlined",
                    density: "default",
                    color: "secondary"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn_toggle, {
                modelValue: _ctx.sortOrder,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortOrder) = $event)),
                mandatory: "",
                class: "ml-4",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-variant-remove",
                    value: "default",
                    size: "small",
                    title: "Default Order"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-alphabetical-ascending",
                    value: "asc",
                    size: "small",
                    title: "Sort Ascending"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-alphabetical-descending",
                    value: "desc",
                    size: "small",
                    title: "Sort Descending"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_tooltip, {
                text: "Refresh Models",
                location: "top"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    color: "primary",
                    variant: "text",
                    icon: "",
                    loading: _ctx.refreshingModels,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshModelsView(true, 'manual')))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-refresh")
                        ])),
                        _: 1,
                        __: [8]
                      })
                    ]),
                    _: 2
                  }, 1040, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.modelIds != null)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedModelIds, (item) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: item.hash,
                  cols: _ctx.isDesktop ? 4 : 12,
                  class: "ma-0 pa-2"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createBlock(_component_ModelSummaryCard, {
                          key: 0,
                          model: _ctx.modelConfigById(item.id),
                          onEdit: _ctx.openEditModelOverlay
                        }, null, 8, ["model", "onEdit"]))
                      : (_openBlock(), _createBlock(_component_ModelCard, {
                          key: 1,
                          modelId: item.id,
                          showTips: _ctx.showTips,
                          startExpanded: _ctx.modelNameById(item.id) === _ctx.expandedModelName,
                          onSaved: _ctx.handleModelSaved
                        }, null, 8, ["modelId", "showTips", "startExpanded", "onSaved"]))
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128)),
              (_ctx.count === 0)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: _ctx.isDesktop ? 4 : 12,
                    class: "ma-0 pa-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        onClick: _ctx.openCreateModelOverlay,
                        class: "ma-0 pa-2 card add-card",
                        color: "surface",
                        density: "compact",
                        variant: "elevated",
                        elevation: "4",
                        "min-height": "350"
                      }, {
                        default: _withCtx(() => [
                          _cache[9] || (_cache[9] = _createElementVNode("p", null, "New model", -1)),
                          _createVNode(_component_v_icon, {
                            class: "add-icon",
                            icon: "mdi-plus"
                          })
                        ]),
                        _: 1,
                        __: [9]
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["cols"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0 mt-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2 d-flex align-center"
          }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "mr-4" }, "Voices", -1)),
              (_ctx.voicesCount > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    buttonClass: "ml-1",
                    icon: "mdi-plus",
                    click: _ctx.openCreateVoiceOverlay,
                    size: "x-large",
                    tooltip: "New Voice",
                    variant: "outlined",
                    density: "default",
                    color: "secondary"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn_toggle, {
                modelValue: _ctx.voiceSortOrder,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.voiceSortOrder) = $event)),
                mandatory: "",
                class: "ml-4",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-variant-remove",
                    value: "default",
                    size: "small",
                    title: "Default Order"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-alphabetical-ascending",
                    value: "asc",
                    size: "small",
                    title: "Sort Ascending"
                  }),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-sort-alphabetical-descending",
                    value: "desc",
                    size: "small",
                    title: "Sort Descending"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1,
            __: [10]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedVoiceIds, (item) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: item.hash,
              cols: _ctx.isDesktop ? 4 : 12,
              class: "ma-0 pa-2"
            }, {
              default: _withCtx(() => [
                (_ctx.isDesktop)
                  ? (_openBlock(), _createBlock(_component_VoiceSummaryCard, {
                      key: 0,
                      voice: _ctx.voiceConfigById(item.id),
                      onEdit: _ctx.openEditVoiceOverlay
                    }, null, 8, ["voice", "onEdit"]))
                  : (_openBlock(), _createBlock(_component_VoiceCard, {
                      key: 1,
                      voiceId: item.id,
                      startExpanded: _ctx.voiceNameById(item.id) === _ctx.expandedVoiceName,
                      onSaved: _ctx.handleVoiceSaved
                    }, null, 8, ["voiceId", "startExpanded", "onSaved"]))
              ]),
              _: 2
            }, 1032, ["cols"]))
          }), 128)),
          (_ctx.voicesCount === 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: _ctx.isDesktop ? 4 : 12,
                class: "ma-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    onClick: _ctx.openCreateVoiceOverlay,
                    class: "ma-0 pa-2 card add-card",
                    color: "surface",
                    density: "compact",
                    variant: "elevated",
                    elevation: "12",
                    "min-height": "350"
                  }, {
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createElementVNode("p", null, "New voice", -1)),
                      _createVNode(_component_v_icon, {
                        class: "add-icon",
                        icon: "mdi-plus"
                      })
                    ]),
                    _: 1,
                    __: [11]
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showCreateModelOverlay,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCreateModelOverlay) = $event)),
        title: "New Model",
        onClose: _ctx.closeCreateModelOverlay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ModelCard, {
            isOverlay: "",
            showTips: _ctx.showTips,
            onRemoveCard: _ctx.closeCreateModelOverlay,
            onSaved: _ctx.handleModelSaved
          }, null, 8, ["showTips", "onRemoveCard", "onSaved"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showEditModelOverlay,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showEditModelOverlay) = $event)),
        title: "Edit Model",
        onClose: _ctx.closeEditModelOverlay
      }, {
        default: _withCtx(() => [
          (_ctx.editingModelId)
            ? (_openBlock(), _createBlock(_component_ModelCard, {
                key: 0,
                modelId: _ctx.editingModelId,
                isOverlay: "",
                showTips: _ctx.showTips,
                startExpanded: true,
                onRemoveCard: _ctx.closeEditModelOverlay,
                onSaved: _ctx.handleModelSaved
              }, null, 8, ["modelId", "showTips", "onRemoveCard", "onSaved"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showCreateVoiceOverlay,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCreateVoiceOverlay) = $event)),
        title: "New Voice",
        onClose: _ctx.closeCreateVoiceOverlay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VoiceCard, {
            isOverlay: "",
            onRemoveCard: _ctx.closeCreateVoiceOverlay,
            onSaved: _ctx.handleVoiceSaved
          }, null, 8, ["onRemoveCard", "onSaved"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showEditVoiceOverlay,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showEditVoiceOverlay) = $event)),
        title: "Edit Voice",
        onClose: _ctx.closeEditVoiceOverlay
      }, {
        default: _withCtx(() => [
          (_ctx.editingVoiceId)
            ? (_openBlock(), _createBlock(_component_VoiceCard, {
                key: 0,
                voiceId: _ctx.editingVoiceId,
                isOverlay: "",
                startExpanded: true,
                onSaved: _ctx.handleVoiceSaved
              }, null, 8, ["voiceId", "onSaved"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ]),
    _: 1
  }))
}